import { TextField } from "@mui/material";

export const templateLanguageToHtmlLang = (language) => {
  const code = String(language || "pt_BR").trim();
  if (!code) return "pt-BR";
  if (code.includes("-")) return code;
  return code.replace("_", "-");
};

/**
 * TextField com corretor ortográfico nativo do navegador (mesmo comportamento do MessageInput).
 */
const SpellCheckTextField = ({ language, inputProps, ...props }) => {
  const lang = templateLanguageToHtmlLang(language);

  return (
    <TextField
      {...props}
      spellCheck
      inputProps={{
        ...inputProps,
        spellCheck: true,
        lang,
      }}
    />
  );
};

export default SpellCheckTextField;
